
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const DailyLivingActivitiesSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const sections = [
    { name: "dailyLiving.arrivalMethod", label: "child-patient-assessment.arrival-method", desc: "dailyLiving.arrivalMethodDescription" },
    { name: "dailyLiving.consciousness", label: "child-patient-assessment.consciousness", desc: "dailyLiving.consciousnessDescription" },
    { name: "dailyLiving.sleepPattern", label: "child-patient-assessment.sleep-pattern", desc: "dailyLiving.sleepPatternDescription" },
    { name: "dailyLiving.excretion", label: "child-patient-assessment.excretion", desc: "dailyLiving.excretionDescription" },
    { name: "dailyLiving.hygieneHabits", label: "child-patient-assessment.hygiene-habits", desc: "dailyLiving.hygieneHabitsDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("child-patient-assessment.patient-info")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={2}>
        {sections.map((sec) => (
          <Grid key={sec.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sec.label)}>
              <Controller
                name={sec.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    sx={{ pt: 1 }}
                  />
                )}
              />
              <ByzTitleAndInputBox
                marginLeft="0px"
                sx={{ marginTop: "8px" }}
                title={t("description", "capitalize")}
              >
                <Controller
                  name={sec.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid container spacing={2}>
        {[
          { name: "dailyLiving.nutrition", label: "child-patient-assessment.nutrition", desc: "dailyLiving.nutritionDescription" },
          { name: "dailyLiving.nutritionType", label: "child-patient-assessment.nutrition-type", desc: "dailyLiving.nutritionTypeDescription" },
          { name: "dailyLiving.appetite", label: "child-patient-assessment.appetite", desc: "dailyLiving.appetiteDescription" },
        ].map((sec) => (
          <Grid key={sec.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sec.label)}>
              <Controller
                name={sec.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    sx={{ pt: 1 }}
                  />
                )}
              />
              <ByzTitleAndInputBox
                marginLeft="0px"
                sx={{ marginTop: "8px" }}
                title={t("description", "capitalize")}
              >
                <Controller
                  name={sec.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
